import { isDeepEqual } from '@attain-apps/data-utils'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as rules from '../../rules'
import type { TypeParams } from '../types'

/**
 * We need to cleanup various resources if the app gets unselected.
 *
 * For example: when we navigate to home app, or the app that doesn't have
 * "pages".
 */
export const setApplicableRulesForCurrentRecord = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    recordCollection: ec.Collection<TypeParams>,
    rulesCollection: ec.Collection<rules.TypeParams>,
  ) => {
    let hasSetRules = false
    return recordCollection.plugins.currentEntityPlugin.feature.selectors
      .getEntity()
      .asObservable.pipe(
        rxjs.map(record => record?.applicableRuleIds),
        rxjs.startWith(undefined),
        // We only need to set the rules list if the applicable rules have
        // changed
        rxjs.distinctUntilChanged(isDeepEqual),
        rxjs.map(ruleIds => {
          const source = 'setApplicableRulesForCurrentRecord (effect)'
          if (!ruleIds) {
            if (!hasSetRules) {
              // If we have not yet set the rules, no need to reset
              return store.effects.SKIP
            }
            // If there are no applicable rule IDs, presumably we have not
            // current GL record, so we can just reset to showing all rules
            return rulesCollection.plugins.currentListPlugin.feature.actions.load
              .from(source)
              .create()
          }
          hasSetRules = true
          // If we have applicable rule IDs, we should just show them
          return rulesCollection.plugins.currentListPlugin.feature.actions.set
            .from(source)
            .create({ ids: ruleIds.map(id => id.toString()) })
        }),
      )
  },
)
